'use strict';

var React = require('react');

class BroadcastInfo extends React.Component {
	render() {
		var text = this.props.teaser && this.props.teaser.broadcastInfo;
		if (!text) {
			return false;
		}

		return (
			<span className={this.props.className}>{text}</span>
		);
	}
}
BroadcastInfo.displayName = 'BroadcastInfo';
BroadcastInfo.propTypes = {
	teaser: React.PropTypes.shape({
		broadcastInfo: React.PropTypes.string
	}).isRequired,
	className: React.PropTypes.string
};


module.exports = BroadcastInfo;




/** WEBPACK FOOTER **
 ** ./app/components/Teaser/BroadcastInfo.jsx
 **/